import { render, staticRenderFns } from "./VenueNameTag.vue?vue&type=template&id=a38793e4"
import script from "./VenueNameTag.vue?vue&type=script&lang=js"
export * from "./VenueNameTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports